import project1 from '../img/projects/project1.png';
import project2 from '../img/projects/project2.png';
import project3 from '../img/projects/project3.png';
import project4 from '../img/projects/project4.png';

import translate from "../Translation/i18nProvider/translate";

const projects = [
    {
        id: 1,
        image: project1,
        title: translate('project1_title_1'),
        link: 'https://netflix-build-e0661.web.app/',
        year: '2020',
        titleSourse: translate('project_titlesourse'),
        linkSourse: 'https://github.com/MishaHubka1/netflix_clone/',
        description: 'React.js Firebase'
    },
    {
        id: 2,
        image: project2,
        title: translate('project2_title_1'),
        link: 'https://lk-react-40849.web.app/home',
        year: '2020',
        titleSourse: translate('project_titlesourse'),
        linkSourse: 'https://github.com/MishaHubka1/social_network--post_page',
        description: translate('project2_description') 
    },
    {
        id: 3,
        image: project3,
        title: translate('project3_title_1'),
        link: 'https://ecommerce-react-next-js.vercel.app/',
        year: '2021',
        description: 'React.js Next.js Mongo.db-atlas Cloudinary'
    },
    {
        id: 4,
        image: project4,
        title: translate('project4_title_1'),
        link: 'https://snapchat-clone-4cb36.web.app/chats',
        year: '2021',
        description: 'React.js Firebase'
    }
];

export default projects;